<template>
    <div class="index">
        <div class="top_navigation">
            <div class="bg_big"></div>
            <div class="logo_box">
                <img class="img_box" src="../../../assets/icons/官网首页_slices/公司logo.png" alt="">
            </div>
            <div class="user_box">
                <div class="user_name">{{ user.name }}</div>
                <i @click="exit()" class="i_box el-icon-switch-button"></i>
            </div>
        </div>
        <div class="tab_box">
            <div 
                @click="tabclick(item)"
                :class="active==item.id?'active':''"
                class="tab_item" 
                v-for="(item,index) of tab" :key="index">
                {{ item.title }}
            </div>
        </div>
        <div class="content_box">
            <router-view></router-view>
        </div>
        <!-- 退出登录 -->
        <el-dialog
            title="信息提示"
            :visible.sync="dialogVisibleout"
            class="dialog_out"
            width="30%">
            <div class="dialog_pointer">
                <img style="width: 25px; height: 25px;border-radius: 50%;" src="https://img1.baidu.com/it/u=4049022245,514596079&fm=253&fmt=auto&app=120&f=JPEG?w=889&h=500" alt="" srcset="">
                
                <div class="dialog_pointer_right">
                    <div class="dialog_pointer_right_top">确定要退出登录吗？</div>
                    <div class="dialog_pointer_right_bottom">退出登录，会放弃当前所有操作~</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleout = false">取 消</el-button>
                <el-button type="primary" @click="logout()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisiblecp"
            class="dialog_change"
            width="30%">
            <div class="dialog_change">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="原密码" prop="opw">
                        <el-input clearable show-password v-model="ruleForm.opw" placeholder="请输入原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="npw">
                        <el-input clearable show-password v-model="ruleForm.npw" placeholder="6~16位字符,区分大小写"></el-input>
                    </el-form-item>
                    <el-form-item label="确定密码" prop="cpw">
                        <el-input clearable show-password v-model="ruleForm.cpw" placeholder="在此输入新密码"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisiblecp = false">取 消</el-button>
                <el-button type="primary" @click="changepw('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>

export default {
    components:{},
    data() {
      return {
        dialogVisibleout:false,//退出登录弹框
        dialogVisiblecp:false,//修改密码弹框
        ruleForm: {
            opw: null,
            npw: null,
            cpw: null,
        },
        user:{},
        rules: {
            opw: [
                { required: true, message: '请输入原密码', trigger: 'blur' },
                { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }],
            npw: [
                { required: true, message: '请输入新密码', trigger: 'blur' },
                { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
            ],
            cpw: [
                { required: true, message: '请再次输入新密码', trigger: 'blur' },
                { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
            ],
        },
        tab:[
            {path:'/home',title:'首页配置',id:1},
            {path:'/proandser',title:'产品与服务配置',id:2},
            {path:'/hrdigitize',title:'HR数字化转型',id:5},
            {path:'/case',title:'案例配置',id:3},
            {path:'/hire',title:'招聘配置',id:6},
            {path:'/foundation',title:'基础信息配置',id:4},
        ],
        active:null,
      }
    },
    created(){
        this.user=JSON.parse( sessionStorage.getItem('user'))
        // this.active=this.tab[0].id
        this.tab.forEach((item)=>{
            if(item.path==this.$route.path){
                this.active=item.id
            }
        })
        
    },
    methods:{
        tabclick(item){
            this.active=item.id
            this.$router.push({
                path:item.path
            })
        },
        //修改密码确定
        changepw(ruleForm){
            this.$refs[ruleForm].validate((valid) => {
            if (valid) {
                let validate=false
                let obj={
                    "newPassword": this.ruleForm.npw,
	                "oldPassword": this.ruleForm.opw
                }
                if(this.ruleForm.npw==this.ruleForm.cpw){
                    validate=true
                }else{
                    this.$message({
                        message: '新密码与再次输入密码不一致',
                        type: 'error'
                    });
                }
                if(validate==true){
                    this.$http.put('/userPassword',obj).then((res)=>{
                        if(res.code==200){
                            this.$message({
                                message:'修改密码成功,请重新登录',
                                type:'success'
                            })
                            this.dialogVisiblecp=false;
                            sessionStorage.clear
                            this.$router.push('/login')
                        }else if(res.code==401){
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                            this.$router.push('/login')
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }
            } else {
                return false;
            }
            });
        },
        exit(){
            this.dialogVisibleout=true
        },
        //确定退出登录
        logout(){
            this.$http.delete(`v1/logout?userId=${this.user.id}`).then((res)=>{
                if(res.code==200){
                    this.$message.success(res.message)
                    sessionStorage.clear()
                    this.$router.push('/login')
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        //退出登录按钮 1:修改密码 2:退出登录
        out(e){
            if(Number(e)==1){
                this.dialogVisiblecp=true;
            }else if(Number(e)==2){
                this.dialogVisibleout=true;
            }
        },
    }
  };
</script>
<style lang="less" scoped>
    .index{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        .content_box{
            width: 100%;
            box-sizing: border-box;
            padding-left: 5%;
            height: 85%;
            overflow: hidden;
            overflow-y: scroll;
        }
        .tab_box{
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            padding-left: 5%;
            display: flex;
            align-items: center;
            user-select: none;
            .tab_item{
                box-sizing: border-box;
                height: 50px;
                width: 200px;
                line-height: 50px;
                text-align: center;
                border-bottom: 5px solid transparent;
                color: #333;
                font-size: 18px;
                cursor: pointer;
            }
            .active{
                border-bottom: 5px solid #6D000E;
                color: #6D000E;
            }
        }
        .top_navigation{
            box-sizing: border-box;
            width: 100%;
            height: 75px;
            position: relative;
            .bg_big{
                width: 100%;
                height: 100%;
                position: relative;
            }
            .bg_big::before{
                content:'';
                position:absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background: url('../../../assets/icons/u961.svg') repeat;
                z-index: 1;
            }
            .bg_big::after{
                content: '';
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background: url(../../../assets/icons/two.png) no-repeat;
                 background-size: 100% 100%;
                z-index: 2;
                opacity: 0.4;
            }
            .logo_box{
                width: 50%;
                height: 100%;
                box-sizing: border-box;
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 3;
                display: flex;
                align-items: center;
                .img_box{
                 
                    margin-left:50px;
                    margin-right: 15px;
                }
                .font_box{
                    font-size: 24px;
                    color: #fff;
                    font-weight: bold;
                }
            }
            .user_box{
                width: 10%;
                height: 100%;
                box-sizing: border-box;
                position: absolute;
                top: 0px;
                right: 60px;
                z-index: 3;
                display: flex;
                align-items: center;
                .user_name{
                    margin: 0px 10px;
                }
                .i_box{
                    font-size: 18px;
                    font-weight: bold;
                    width: 24px;
                    height: 24px;
                    text-align: center;
                    line-height: 24px;
                    cursor: pointer;
                }
            }
        }
        
    }
    .dialog_out{
        .dialog_pointer{
            display: flex;
            align-items: center;
            .dialog_pointer_right{
                padding: 0px 10px;
                .dialog_pointer_right_top{

                }
            }
        }
    }
  .el-aside {
    color: #333;
  }
</style>
